module.exports = "<ion-modal-view>\n  <ion-content has-bouncing=\"false\" scroll=\"false\">\n    <div class=\"vui-view\">\n      <div class=\"vui-bar vui-bar-header vui-has-button\">\n        <button class=\"vui-button vui-button-icon-left\" ng-click=\"hideModal(2)\">返回</button>\n        <h1 class=\"vui-bar-title\">带按钮的标题</h1>\n        <button class=\"vui-button vui-button-primary\">按钮</button>\n      </div>\n      <div class=\"vui-content vui-has-header\">\n        <div class=\"vui-padding\">\n          带按钮的标题\n        </div>\n      </div>\n    </div>\n  </ion-content>\n</ion-modal-view>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/bar/modal2.html
// module id = 7
// module chunks = 0